const REGEX = {
    YOUTUBE_REGEX: /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|.*\/))([^?&/\s]+)/,
    USER_NAME_REGEX: /[^a-z1-9_]/g
}

export default REGEX;